import React from 'react';
import { motion } from 'framer-motion';
import { Scale, Clock, ShieldCheck } from 'lucide-react';
import { Button } from './ui/Button';
import { Countdown } from './ui/Countdown';
export function FinalCloseSection() {
  return <section className="py-12 md:py-16 bg-dark text-white relative overflow-hidden" data-id="element-107">
      {/* Decorative background */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_bottom_left,_var(--tw-gradient-stops))] from-coral/20 via-dark to-dark opacity-50" data-id="element-108"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-109">
        {/* Cost of not acting */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-110">
          <div className="inline-flex items-center justify-center gap-2 text-gold font-bold tracking-wider uppercase mb-6" data-id="element-111">
            <Scale className="w-6 h-6" data-id="element-112" />
            <span data-id="element-113">⚖️ ¿CUÁNTO CUESTA NO EMPEZAR HOY?</span>
          </div>

          <ul className="space-y-4 text-lg md:text-xl text-cream-dark max-w-2xl mx-auto text-left md:text-center mb-12" data-id="element-114">
            <li className="flex items-start md:items-center gap-3 justify-start md:justify-center" data-id="element-115">
              <span className="text-coral mt-1 md:mt-0" data-id="element-116">❌</span>
              <span data-id="element-117">
                Seguir dependiendo de parches temporales que no solucionan tu
                ansiedad.
              </span>
            </li>
            <li className="flex items-start md:items-center gap-3 justify-start md:justify-center" data-id="element-118">
              <span className="text-coral mt-1 md:mt-0" data-id="element-119">❌</span>
              <span data-id="element-120">
                Seguir sintiéndote abrumado/a por la rutina sin saber cómo
                frenar la cabeza.
              </span>
            </li>
            <li className="flex items-start md:items-center gap-3 justify-start md:justify-center" data-id="element-121">
              <span className="text-coral mt-1 md:mt-0" data-id="element-122">❌</span>
              <span data-id="element-123">
                Seguir gastando energía en relaciones que te desgastan por no
                saber decir «no».
              </span>
            </li>
            <li className="flex items-start md:items-center gap-3 justify-start md:justify-center" data-id="element-124">
              <span className="text-coral mt-1 md:mt-0" data-id="element-125">❌</span>
              <span data-id="element-126">
                Seguir postergando tu salud mental porque "no te dan los
                números" para una consulta.
              </span>
            </li>
          </ul>

          <div className="bg-white/5 border border-white/10 p-6 rounded-2xl inline-block" data-id="element-127">
            <p className="text-xl md:text-2xl font-display font-medium text-white" data-id="element-128">
              El mejor momento para priorizarte era ayer.
              <br data-id="element-129" />
              <span className="text-gold font-bold" data-id="element-130">
                El segundo mejor momento es hoy.
              </span>
            </p>
          </div>
        </motion.div>

        {/* Final CTA Box */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-white rounded-[2.5rem] p-8 md:p-12 text-center text-dark shadow-2xl relative" data-id="element-131">
          <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 bg-coral text-white px-6 py-2 rounded-full font-bold text-sm flex items-center gap-2 whitespace-nowrap shadow-lg" data-id="element-132">
            <Clock className="w-4 h-4" data-id="element-133" />⏰ EL PRECIO DE LANZAMIENTO TERMINA EN:
          </div>

          <div className="mt-6 mb-8" data-id="element-134">
            <Countdown data-id="element-135" />
          </div>

          <h3 className="text-2xl md:text-3xl font-display font-bold text-dark mb-4" data-id="element-136">
            🧠 ESTE LIBRO ES MÁS BARATO QUE LA TERAPIA™
          </h3>

          <p className="text-lg text-dark-light font-medium mb-8" data-id="element-137">
            📘 Libro Digital Completo + 🎁 4 Bonos Exclusivos
          </p>

          <div className="bg-cream p-4 rounded-xl inline-block mb-8" data-id="element-138">
            <p className="text-dark-light font-medium" data-id="element-139">
              Precio Regular: <span className="line-through" data-id="element-140">$49.999</span> |{' '}
              <span className="text-coral font-bold text-xl" data-id="element-141">
                HOY: $19.999 ARS
              </span>
            </p>
          </div>

          <Button className="w-full md:w-auto text-lg px-12 py-5 mb-6 shadow-xl" data-id="element-142">
            👉 ➜ QUIERO EMPEZAR MI CAMBIO HOY
          </Button>

          <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-xs md:text-sm text-dark-light font-medium" data-id="element-143">
            <div className="flex items-center gap-1" data-id="element-144">
              <ShieldCheck className="w-4 h-4 text-teal" data-id="element-145" />
              <span data-id="element-146">Pago seguro</span>
            </div>
            <span className="hidden md:inline text-cream-dark" data-id="element-147">•</span>
            <span data-id="element-148">Acceso inmediato</span>
            <span className="hidden md:inline text-cream-dark" data-id="element-149">•</span>
            <span data-id="element-150">Garantía 7 días</span>
            <span className="hidden md:inline text-cream-dark" data-id="element-151">•</span>
            <span className="text-coral font-bold" data-id="element-152">
              Cupos limitados por lanzamiento
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}